import checkoutFormModel from "./welcomeFormModel";
const {
  formField: { chkSlideShowWatched, preferredDayTime },
} = checkoutFormModel;

export default {
  [chkSlideShowWatched.name]: false,
  [preferredDayTime.name]: "",
};
